import React from 'react';
import { connect } from 'react-redux';
import ActionButton from '../../elements/ActionButton/ActionButton';
import LeftTabbedGrayHeader from '../../elements/headers/LeftTabbedGrayHeader';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import Screen from '../Screen';
import styles from './MyProfile.module.scss';

class MyProfileScreen_Photo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        var { i18n, langNames, available } = this.props;

        var languages = available.map(
            function (locale) {
                if (langNames[locale])
                    return (
                        <ActionButton
                            className={styles.ActionButton}
                            tab
                            next
                            primary
                            onClick={this.handleLanguageChange.bind(
                                this,
                                locale
                            )}
                            key={locale}
                        >
                            {langNames[locale]}
                        </ActionButton>
                    );
            }.bind(this)
        );

        const header = (
            <>
                <TopBar returnURL=".." />
                <hr />
            </>
        );
        return (
            <Screen header={header}>
                <Scrollable>
                    <LeftTabbedGrayHeader>
                        {i18n['label.select.language']}
                    </LeftTabbedGrayHeader>
                    <br />
                    <br />
                    <div className="indent">{languages}</div>
                </Scrollable>
            </Screen>
        );
    }
    handleLanguageChange(locale) {
        app.store.dispatch(app.actions.ui.busy());
        app.api.users
            .updateUserProfile(this.props.userId, { language_code: locale })
            .then(() => {
                app.history.push('/my_profile');
            })
            .catch((err) => console.error(err))
            .then(() => {
                app.store.dispatch(app.actions.ui.free());
            });
    }
}

export default connect(function (state, props) {
    return {
        i18n: state.i18n.translations,
        available: state.i18n.availableLanguages,
        langNames: state.i18n.langNames,
        userId: state.session.user.id,
    };
})(MyProfileScreen_Photo);
